import { useState, type FormEvent } from "react";
import { useAdminAuth } from "../state/AdminAuthContext";

export function LoginScreen() {
  const { login, loading, error, clearError } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!/.+@.+\..+/.test(email)) {
      clearError();
      return;
    }
    void login(email, password);
  };

  return (
    <div className="o-auth o-auth--ink">
      <div className="o-auth__word" aria-hidden="true">
        CLIQ
        <br />
        SUITE
        <br />
        <span style={{ color: "var(--coral)" }}>ADMIN</span>
      </div>
      <div className="o-auth__pitch">
        <div className="o-auth__line" style={{ fontSize: 30 }}>Platform operations</div>
        <ul>
          <li><span className="ms" aria-hidden="true">check_circle</span>Approve &amp; activate instantly</li>
          <li><span className="ms" aria-hidden="true">check_circle</span>Inspect proof screenshots &amp; TXIDs</li>
          <li><span className="ms" aria-hidden="true">check_circle</span>Audit log of every change</li>
        </ul>
      </div>
      <main className="o-auth__card" style={{ width: 460 }}>
        <form className="o-auth__form" onSubmit={handleSubmit}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.2, color: "var(--coral)" }}>ADMIN</div>
            <h1 className="o-auth__title" style={{ marginTop: 4 }}>Administrator sign-in</h1>
          </div>
          <label className="o-ifield">
            <span className="o-field__label">Email</span>
            <span className="o-ifield__box">
              <span className="ms" aria-hidden="true">mail</span>
              <input aria-label="Email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </span>
          </label>
          <label className="o-ifield">
            <span className="o-field__label">Password</span>
            <span className="o-ifield__box">
              <span className="ms" aria-hidden="true">lock</span>
              <input aria-label="Password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </span>
          </label>
          {error && (
            <div className="o-error" role="alert" style={{ marginTop: 0 }}>
              {error}
            </div>
          )}
          <button type="submit" className="o-auth__submit" style={{ background: "var(--coral)" }} disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
            {!loading && <span className="ms" aria-hidden="true">arrow_forward</span>}
          </button>
          <div style={{ textAlign: "center", fontSize: 12, fontWeight: 700, color: "var(--muted)" }}>© 2026 CliqSuite Inc., platform operations</div>
        </form>
      </main>
    </div>
  );
}
